export default __webpack_public_path__ + "static/media/prototype_version_3.b277b0d2.png";